<template>
  <div class="alarm-detail__wrap">
    <div class="alarm-detail-panel" :class="{ 'panel-show': showAlarmPanel }">
      <div class="blur-bg"></div>
      <div class="alarm-detail__content">
        <div class="title">上报告警</div>
        <el-scrollbar class="scroll-content" style="height: calc(100% - 60px)">
          <el-form :model="alarmInfo" :rules="alarmForm" ref="alarmForm" label-width="80px">
            <el-form-item label="监控点" prop="name">
              <el-input v-model="alarmInfo.name" readonly placeholder="请选择左侧监控点">
              </el-input>
            </el-form-item>
            <el-form-item label="告警类型" prop="alarmType">
              <el-select v-model="alarmInfo.alarmType" style="width: 100%" placeholder="请选择告警类型">
                <el-option v-for="item in alarmTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option></el-select>
            </el-form-item>
            <el-form-item label="告警级别" prop="alarmLevel">
              <el-select v-model="alarmInfo.alarmLevel" style="width: 100%" placeholder="请选择告警级别">
                <el-option v-for="item in alarmLevels" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="告警描述" prop="desc">
              <el-input v-model="alarmInfo.desc" placeholder="请输入告警描述" type="textarea" maxlength="200" show-word-limit
                rows="5" resize="none"></el-input>
            </el-form-item>
            <el-form-item label="抓拍图片" prop="picture" label-width="80px">
              <template>
                <div class="file-upload-area">
                  <div class="file-list">
                    <div class="file-item" v-for="(item, index) in alarmInfo.pictureList" :key="index">
                      <img class="file-comp" :src="$utils.Bus.imgPath(item.fileId)" />
                      <div class="delete-icon" @click="pictureRemove(index)">
                        <i class="el-icon-delete"></i>
                      </div>
                    </div>
                  </div>
                  <el-upload :class="{ hideUpload: alarmInfo.pictureList.length >= 3 }" :action="uploadUrl" name="files"
                    list-type="picture-card" accept="image/png, image/jpg, image/jpeg, image/bpm"
                    :before-upload="pictureBefore" :on-exceed="pictureExceed" :on-success="pictureSuccess"
                    :file-list="alarmInfo.pictureList" :show-file-list="false" :auto-upload="true" multiple :limit="3"
                    ref="uploadPicture">
                    <el-button slot="trigger" size="small" type="text">
                      <i class="el-icon-circle-plus-outline" title="本地上传"></i>
                      <i class="el-icon-camera" @click.stop="handleSnap" title="快速抓拍"></i>
                    </el-button>
                  </el-upload>
                </div>
              </template>
            </el-form-item>
          </el-form>
        </el-scrollbar>

        <div class="footer">
          <el-button @click="handleClosePanel" type="info">取消</el-button>
          <el-button type="primary" @click="handleConfirmPanel">立即上报</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import { Dic, Dates } from "$utils";
export default {
  name: "alarm-panel",
  props: {
    taskDetailCode: {
      type: String,
      default: () => {
        return "";
      },
    },
    code: {
      type: String,
      default: () => {
        return "";
      },
    },
    showAlarmPanel: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      uploadUrl: api.videoTask.upFile,
      alarmForm: {
        name: [{ required: true, message: "请选择左侧监控点", trigger: "blur" }],
        alarmType: [{ required: true, message: "请选择告警类型", trigger: "blur" }],
        alarmLevel: [{ required: true, message: "请选择告警等级", trigger: "blur" }],
      },
      alarmInfo: {
        position: "",
        alarmType: "",
        alarmLevel: "",
        desc: "",
        picture: "",
        pictureList: [],
        name: "",
        thirdCameraId: "",
      },
      alarmLevels: Dic.find("SENU017"), //告警级别
      alarmTypes: Dic.find("SENU004010"),
      snapFlag: false
    };
  },
  methods: {
    // 快速抓拍
    handleSnap() {
      // this.$emit("handleSnap");
      this.$emit("handleSnap", this.alarmInfo.thirdCameraId);
    },
    handleConfirmPanel() {
      // console.log('receive taskDetailCode', this.taskDetailCode)
      this.$refs.alarmForm.validate((result) => {
        if (result) {
          let params = {
            desc: this.alarmInfo.desc,
            alarmType: this.alarmInfo.alarmType,
            alarmLevel: this.alarmInfo.alarmLevel,
            // alarmSnapUrl: (this.alarmInfo.pictureList || [])
            //   .map((item) => {
            //     return item.fileId;
            //   })
            //   .join(","),
            picUrl: (this.alarmInfo.pictureList || [])
              .map((item) => {
                return item.fileId;
              })
              .join(","),
            isApp: 0,
            // longitude: this.alarmInfo.position.split(",")[0],
            // latitude: this.alarmInfo.position.split(",")[1],
            thirdAlarmDevId: this.alarmInfo.thirdCameraId,
          };
          this.$fetch(api.videoTask.operateAlarm, params).then((response) => {
            if (response.success) {
              // this.successAlarm();
              this.isReportPanel = false;
              let param = {
                taskCode: this.code,
                taskDetailCode: this.taskDetailCode,
                alarmId: response.returnObj,
              };
              this.$fetch(api.videoTask.updateDetail, param).then((res) => {
                if (res.success) {
                  this.$message.success("手动告警成功");
                  this.handleClosePanel();
                } else {
                  this.$message.error(res.msgContent);
                }
              });
            } else {
              this.$message.error(response.msgContent || "手动告警失败");
            }
          });
        }
      });
    },
    pictureSuccess(res) {
      // if (!this.snapFlag) {
      //   this.handleSnap()
      //   this.snapFlag = true
      // } else {
      //   this.alarmInfo.pictureList = this.alarmInfo.pictureList.concat(res.returnObj || []);
      // }
      let imgArr = {
        fileId: res.returnObj
      }
      this.alarmInfo.pictureList = this.alarmInfo.pictureList.concat(imgArr || []);
    },
    pictureExceed() {
      this.$message.warning("最多可上传3张图片");
    },
    pictureRemove(index) {
      this.alarmInfo.pictureList.splice(index, 1);
    },
    pictureBefore(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("视频大小请不要超过2MB");
      }
      return isLt2M;
    },
    handleExactor() {
      this.$emit("handleExactor");
    },
    handleClosePanel() {
      this.$refs.alarmForm.resetFields();
      this.$emit("handleClosePanel");
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";

.blur-bg {
  @include set_theme_color(background-color, map-bg-color);
}

.alarm-detail {
  &__wrap {
    position: absolute;
    top: 0px;
    display: flex;
    right: 0px;
    height: 100%;
    z-index: 2;

    .panel-show {
      padding: 12px;
      width: 340px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0px !important;
      @include set_animation(all);
    }

    .alarm-detail-panel {
      padding: 12px;
      width: 340px;
      height: 100%;
      position: absolute;
      top: 0;
      right: -450px;
      @include set_animation(all);
      background-color: #ffffff;
    }
  }

  &__content {
    height: calc(100% - 24px);
    width: calc(100% - 24px);
    position: absolute;

    .title {
      border-left: 4px solid #407aee;
      position: relative;
      line-height: 16px;
      text-align: left;
      padding-left: 10px;
      font-size: 16px;
      margin: 0px 10px 12px;
    }

    .file-upload-area {
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
    }

    .file-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .file-item {
      margin-right: 10px;
      background-color: #ffffff;
      position: relative;

      .delete-icon {
        position: absolute;
        right: 0;
        top: 0;
        width: 24px;
        height: 24px;
        background-color: rgba($color: #000000, $alpha: 0.5);
        cursor: pointer;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.2s;

        &:hover {
          background-color: rgba($color: #000000, $alpha: 0.8);
        }

        &:active {
          color: #aaaaaa;
        }
      }
    }

    .file-item,
    .file-comp,
    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      height: 100px;
      width: 110px;
      line-height: 110px;
      margin-bottom: 10px;
      @include set_theme_color(background-color, input-default-bg-color);

      &:nth-child(3) {
        margin-right: 0;
      }

      button {
        i {
          font-size: 26px;
          margin-left: 8px;
          margin-right: 8px;
          @include set_theme_color(color, main-theme-color);
        }
      }
    }

    .hideUpload {
      .el-upload--picture-card {
        display: none;
      }
    }

    .row {
      @include set_theme_color(background-color, map-panel-content);
    }

    .item-content {
      margin: 12px;
      display: flex;
      line-height: 24px;
    }

    .item-label {
      width: 80px;
    }

    .item-value {
      line-height: 24px;
    }

    .footer {
      width: 100%;
      text-align: center;
      position: absolute;
    }
  }
}
</style>
